import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * Public (no-JWT) endpoints for the SBL advisor-approval link page (route: sblApproval/:token).
 * Encryption is handled by the existing HTTP interceptor — these paths are intentionally NOT added
 * to plaintext-paths.ts. The `accessToken` is the raw token from the URL.
 */
@Injectable({ providedIn: 'root' })
export class SblApprovalService {
  constructor(private http: HttpClient) {}

  /** Page load — read-only transaction details for the approval link. */
  getTransactionApprovalDetails(accessToken: string): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/public/sbl/get_sbl_transaction_approval_details`,
      { accessToken },
    );
  }

  /** Continue / Resend — sends (or re-sends) the OTP to the client. */
  resendApprovalOtp(accessToken: string): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/public/sbl/resend_sbl_approval_otp`,
      { accessToken },
    );
  }

  /** Submit — verifies the OTP and approves the draw/payment request. */
  approveRequestWithOtp(accessToken: string, otp: string): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/public/sbl/approve_sbl_request_with_otp`,
      { accessToken, otp },
    );
  }
}
